import { render, staticRenderFns } from "./citySelectorsingle.vue?vue&type=template&id=0271e660&scoped=true"
import script from "./citySelectorsingle.vue?vue&type=script&lang=js"
export * from "./citySelectorsingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271e660",
  null
  
)

export default component.exports